/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Povrch obuvi`
};

const da_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Shoe Surface`
};

const de_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Shoe Surface`
};

const en_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Shoe Surface`
};

const es_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Shoe Surface`
};

const fr_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Surface`
};

const hu_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Felület`
};

const it_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Shoe Surface`
};

const nl_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Shoe Surface`
};

const pl_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Powierzchnia buta`
};

const pt_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Shoe Surface`
};

const sv_attributes_shoe_surface = /** @type {(inputs: {}) => string} */ () => {
	return `Stövelns yta`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_shoe_surface = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_shoe_surface(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_shoe_surface", locale)
	if (locale === "cs") return cs_attributes_shoe_surface(inputs)
	if (locale === "da") return da_attributes_shoe_surface(inputs)
	if (locale === "de") return de_attributes_shoe_surface(inputs)
	if (locale === "en") return en_attributes_shoe_surface(inputs)
	if (locale === "es") return es_attributes_shoe_surface(inputs)
	if (locale === "fr") return fr_attributes_shoe_surface(inputs)
	if (locale === "hu") return hu_attributes_shoe_surface(inputs)
	if (locale === "it") return it_attributes_shoe_surface(inputs)
	if (locale === "nl") return nl_attributes_shoe_surface(inputs)
	if (locale === "pl") return pl_attributes_shoe_surface(inputs)
	if (locale === "pt") return pt_attributes_shoe_surface(inputs)
	return sv_attributes_shoe_surface(inputs)
};
export { attributes_shoe_surface as "attributes.shoe_surface" }